import { configureStore } from "@reduxjs/toolkit";
import { listenerMiddleware } from "./listenerMiddleware.js";
import { rootReducer } from "./rootReducer.js";
import type { CmtsReduxThunkExtra } from "./thunkExtra.js";

export type RootState = ReturnType<typeof rootReducer>;

export type CreateCmtsStoreOptions = {
  readonly preloadedState?: Partial<RootState> | undefined;
  readonly thunkExtra?: CmtsReduxThunkExtra | undefined;
};

export function createCmtsStore(options: CreateCmtsStoreOptions = {}) {
  return configureStore({
    reducer: rootReducer,
    ...(options.preloadedState ? { preloadedState: options.preloadedState as RootState } : {}),
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      thunk: { extraArgument: options.thunkExtra ?? {} },
      serializableCheck: true,
      immutableCheck: true,
    }).prepend(listenerMiddleware.middleware),
    devTools: import.meta.env.DEV,
  });
}

export const store = createCmtsStore();
export const cmtsStore = store;

export type AppStore = ReturnType<typeof createCmtsStore>;
export type AppDispatch = AppStore["dispatch"];
